import { render, staticRenderFns } from "./examineTask.vue?vue&type=template&id=4c2dfab4&scoped=true&"
import script from "./examineTask.vue?vue&type=script&lang=js&"
export * from "./examineTask.vue?vue&type=script&lang=js&"
import style0 from "./examineTask.vue?vue&type=style&index=0&id=4c2dfab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2dfab4",
  null
  
)

component.options.__file = "examineTask.vue"
export default component.exports